<template>
  <section class="ProposalPdfPage">
    <v-container>
      <proposal-embedded></proposal-embedded>
     
    </v-container>
  </section>
</template>

<script>
import ProposalEmbedded from '@/components/ProposalEmbedded.vue';
export default {
  components: { ProposalEmbedded },
  name: "ProposalPdfPage",
};
</script>

<style scoped>
.ProposalPdfPage {
  padding: 32px;
}
</style>
